import { CustomAvatarProps, TmdxAvatar } from '@ds';
import { PropsWithChildren, ReactElement } from 'react';

type ModalHeaderWrapperProps = {
  photo?: string;
  header: string;
  subHeader: string;
  topContent?: ReactElement;
  avatarProps?: CustomAvatarProps;
} & PropsWithChildren;

export const ModalHeaderWrapper = ({
  photo,
  children,
  header,
  subHeader,
  topContent,
  avatarProps,
}: ModalHeaderWrapperProps) => {
  return (
    <div className="flex justify-between items-start pb-6 border-b-1 border-base-50">
      <div className="flex gap-5 w-full items-center">
        <TmdxAvatar src={photo} radius="xxl" name={header} isBordered color="primary" size="xxl" {...avatarProps} />
        <div className="flex flex-col flex-1 w-full flex-wrap truncate">
          <div className="flex gap-3 items-center flex-1 truncate w-full">
            <span className="text-hl font-secondary text-base-5 truncate">{header}</span>
            {topContent}
          </div>
          <span className="text-l-r text-base-20 mt-[-4px] mb-3 text-wrap">{subHeader}</span>
          {children}
        </div>
      </div>
    </div>
  );
};
